module.exports = __webpack_public_path__ + "static/media/pasteDay.a87992ac.svg";